import script from "./Roadmap.vue?vue&type=script&setup=true&lang=js"
export * from "./Roadmap.vue?vue&type=script&setup=true&lang=js"

export default script